<template>
  <div>
    <main-header></main-header>
    <div class="page">
      <div class="w1200">
        <div class="shippint-toptitle">
          <div class="left">
            {{language[languagetype].downcenter}}
          </div>
        </div>
        <div class="download-selectbox">
          <span>{{language[languagetype].title}}：</span>
          <input type="text" :placeholder="language[languagetype].pleatitle" class="i1" v-model="title">
          <span>{{language[languagetype].txt}}：</span>
          <div>
            <input type="file" id="file" style="opacity: 0;" class="i2" @change="addFile" ref="inputer" accept=".xls,.xlsx,.docx,.doc,.pdf,.png,.jpg">
            <input type="text" class="i1" v-model="filename">
          </div>
          <a href="javascript:;" @click="selectfile">{{language[languagetype].pleatxt}}</a>
          <a href="javascript:;" @click="upload">{{language[languagetype].up}}</a>
        </div>
        <div class="download-listbox">
          <div class="download-search">
            <div class="searchbox">
              <input type="text" class="i1" :placeholder="language[languagetype].pleafilename" v-model="keyword">
              <div class="searchbtn" @click="find">{{language[languagetype].search}}</div>
            </div>
          </div>
          <div class="order-main-table">
            <div class="order-main-table-th">
              <div></div>
              <div>{{language[languagetype].filename}}</div>
              <div>{{language[languagetype].time}}</div>
              <div>{{language[languagetype].upperson}}</div>
              <div></div>
            </div>
            <ul class="order-main-tabletdlist">
              <li class="order-main-table-td" v-for="(downs,index) in downlist" :key="index">
                <div></div>
                <div>
                  <a :href="downs.url" target="_blank">{{downs.title}}.{{downs.ext}}</a>
                </div>
                <div>{{downs.create_time}}</div>
                <div>{{downs.user}}</div>
                <div>
                  <a :href="downs.url" class="a2" target="_blank">{{language[languagetype].dpwn}}</a>
                </div>
              </li>
            </ul>
            <div class="newslist-pageindex">
              <a href="javascript:;" @click="page(1)">{{language[languagetype].first}}</a>
              <a href="javascript:;" @click="page(cur-1)">{{language[languagetype].prev}}</a>
              <a href="javascript:;" v-if="cur >= 2 && all!=2">...</a>
              <a href="javascript:;" v-for="index in pageindexarr" :key="index" @click="page(index)" :class="{active:cur===index}">{{index}}</a>
              <a href="javascript:;" v-if="all > 2">...</a>
              <a href="javascript:;" @click="page(cur+1)">{{language[languagetype].next}}</a>
              <span>{{language[languagetype].gonga}}{{alllength}}{{language[languagetype].tiao}} {{language[languagetype].gongb}}{{all}}{{language[languagetype].ye}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <toast ref="toasttext"></toast>
  </div>
</template>

<script>
import MainHeader from './header'
import toast from '../components/taast/toast'
import Fetch from '../js/ajaxa'
let languagetext = require('../js/download.json')
export default {
  name: 'about',
  data () {
    return {
      title: '',
      file: '',
      filename: '',
      dddd: {
        a: '123',
        b: '123145'
      },
      username: '',
      lang: 1,
      downlist: [],
      all: 1,
      cur: 1,
      pageindexarr: [],
      language: {},
      languagetype: 'cn',
      alllength: 1,
      keyword: ''
    }
  },
  methods: {
    selectfile: function () {
      // eslint-disable-next-line
      var ie = navigator.appName === 'Microsoft Internet Explorer' ? true : false 
      if (ie) {
        document.getElementById('file').click()
      } else {
        var a = document.createEvent('MouseEvents') // FF的处理
        a.initEvent('click', true, true)
        document.getElementById('file').dispatchEvent(a)
      }
    },
    addFile () {
      const that = this
      var filetypes = ['xls', 'xlsx', 'docx', 'doc', 'pdf', 'png', 'jpg']
      that.file = this.$refs.inputer
      let fileDom = this.$refs.inputer.files[0]
      if (filetypes.indexOf(that.getFileType(fileDom.name)) === -1) {
        that.$refs.toasttext.show(that.language[that.languagetype].err)
        return false
      }
      if (fileDom.size > 2 * 1024 * 1024) {
        that.$refs.toasttext.show(that.language[that.languagetype].size)
        return false
      }
      that.filename = fileDom.name
    },
    getFileType (name) {
      let startIndex = name.lastIndexOf('.')
      if (startIndex !== -1) {
        return name.slice(startIndex + 1).toLowerCase()
      } else {
        return ''
      }
    },
    upload: function () {
      const that = this
      if (this.filename === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].titleerr)
        return false
      }
      if (this.file === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].fileerr)
        return false
      }
      var formdata = new FormData()
      formdata.append('file', that.file.files[0])
      formdata.append('title', that.title)
      formdata.append('user', that.username.customerName)
      formdata.append('lang', 1)

      Fetch.post('Api/fileUp', formdata).then((res) => {
        that.$refs.toasttext.show(that.language[that.languagetype].success)
        that.title = ''
        that.file = ''
        that.filename = ''
      }).catch(err => {
        console.log(err)
      })
    },
    page (index) {
      console.log(index)
      const that = this
      if (index <= 0) {
        index = 1
      }
      if (index >= this.all) {
        index = this.all
      }
      if (index === 1) {
        if (this.all < 2) {
          this.pageindexarr = [1]
        } else {
          this.pageindexarr = [1, 2]
        }
      } else if (index === 2) {
        if (this.all < 3) {
          this.pageindexarr = [1, 2]
        } else {
          this.pageindexarr = [1, 2, 3]
        }
      } else {
        if (this.all < index + 1) {
          this.pageindexarr = [index - 1, index]
        } else {
          this.pageindexarr = [index - 1, index, index + 1]
        }
      }
      this.cur = index
      Fetch.post('Api/down?page' + index, {
        keyword: that.keyword,
        lang: ''
      }).then((res) => {
        that.downlist = res.data
      }).catch(err => {
        console.log(err)
      })
    },
    find: function () {
      const that = this
      Fetch.post('Api/down', {
        keyword: that.keyword,
        lang: ''
      }).then((res) => {
        that.downlist = res.data
        that.all = res.last_page
        that.alllength = res.total
        if (that.all >= 2) {
          that.pageindexarr = [1, 2]
        } else {
          that.pageindexarr = [1]
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  components: {
    MainHeader,
    toast
  },
  created () {
    const that = this
    that.username = JSON.parse(localStorage.getItem('username'))
    if (that.username == null) {
      setTimeout(function () {
        that.$refs.toasttext.show(that.language[that.languagetype].islogin)
      }, 300)
      setTimeout(function () {
        that.$router.push({name: 'login'})
      }, 1000)
    }
    that.lang = sessionStorage.getItem('lang') || 1
    that.language = languagetext
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
    Fetch.post('Api/down', {
      keyword: '',
      lang: ''
    }).then((res) => {
      that.downlist = res.data
      that.all = res.last_page
      that.alllength = res.total
      if (that.all >= 2) {
        that.pageindexarr = [1, 2]
      } else {
        that.pageindexarr = [1]
      }
    }).catch(err => {
      console.log(err)
    })
  },
  beforeCreate () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page{min-height: 400px;background-color: #f6f6f6;padding-bottom: 20px;}
  .shippint-toptitle{height: 92px;padding-top: 9px;display: flex;justify-content: space-between;}
  .shippint-toptitle .left{line-height: 92px;color: #333;font-size: 30px;}
  .download-selectbox{width: 100%;height: 80px;overflow: hidden;box-sizing: border-box;padding: 20px 30px;background-color: #fff;display: flex;align-items: center;}
  .download-selectbox span{line-height: 40px;color: #999;font-size: 14px;}
  .download-selectbox .i1{display: block;width: 200px;height: 32px;line-height: 30px;color: #333;font-size: 14px;text-indent: 10px;border:none;outline:none;box-sizing: border-box;border: 1px solid #c5c5c5;margin-right: 20px;}
  .download-selectbox div{width: 200px;height: 32px;position: relative;}
  .download-selectbox div input{position:absolute;top: 0;left: 0;}
  .download-selectbox div .i2{z-index: 10;}
  .download-selectbox a{width: 110px;height: 32px;border-radius: 2px;height: 32px;line-height: 32px;text-align: center;margin-left: 5px;cursor: pointer;background-color: #2562EF;border:1px solid #2562EF;color: #fff;cursor: pointer;}
  .download-listbox{width: 100%;min-height: 400px;box-sizing: border-box;padding: 20px 30px 0 30px;background-color: #fff;margin-top: 20px;}
  .download-listbox .download-search{width: 100%;height: 40px;cursor: pointer;}
  .searchbox{width: 270px;height: 40px;float: right;display: flex;background-color: #F6F6F6;}
  .searchbox .i1{width: 196px;height: 40px;padding-left: 54px;background: url("../assets/sou_js_ss.png") 11px center no-repeat;border: none;outline: none;font-size: 14px;color: #999;}
  .searchbox .searchbtn{width: 74px;height: 40px;line-height: 40px;text-align: center;font-size: 14px;color: #999;}
  .order-main-table{width: 100%;height: auto;box-sizing: border-box;margin-top: 17px;padding-bottom: 15px;}
  .order-main-table-th{width: 100%;height: 50px;overflow: hidden;display: flex;background-color: #f6f6f6;}
  .order-main-table-th div{flex-shrink: 0;height: 50px;font-weight: bold;line-height: 50px;}
  .order-main-table-th div:nth-child(1){width: 23px;}
  .order-main-table-th div:nth-child(2){width: 278px;}
  .order-main-table-th div:nth-child(3){width: 223px;}
  .order-main-table-th div:nth-child(4){width: 425px;}
  .order-main-table-th div:nth-child(5){width: 189px;}
  .order-main-tabletdlist{width: 100%;height: auto;overflow: hidden;}
  .order-main-tabletdlist li{width: 100%;height: auto;overflow: hidden;}
  .order-main-tabletdlist li:nth-child(even){background-color: #f6f6f6;}
  .order-main-table-td{width: 100%;height: auto;display: flex;}
  .order-main-table-td div{flex-shrink: 0;height: 65px;min-height: 65px;color: #999999;font-size: 12px;line-height: 65px;box-sizing: border-box;box-sizing: border-box;padding-left: 4px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
  .order-main-table-td div span{line-height: 35px;display: block;width: 100%;height: auto;}
  .order-main-table-td div a{color: #2D5CC8;}
  .order-main-table-td div:nth-child(1){width: 23px;}
  .order-main-table-td div:nth-child(2){width: 278px;}
  .order-main-table-td div:nth-child(3){width: 223px;}
  .order-main-table-td div:nth-child(4){width: 425px;}
  .order-main-table-td div:nth-child(5){width: 189px;display: flex;justify-content: center;}
  .order-main-table-td:hover{background-color: #a4b3d7!important;}
  .order-main-table-td:hover div,.order-main-table-td:hover a{color: #fff;}
  .order-main-table-td .a2{padding-left: 23px;background:url("../assets/heise_x_z.png") 0 center no-repeat;display: block;}
  .order-main-table-td:hover .a2{padding-left: 23px;background:url("../assets/baise_x_z.png") 0 center no-repeat;display: block;}
  .newslist-pageindex{width: 100%;height: auto;overflow: hidden;text-align: center;margin-bottom: 5px;margin-top: 15px;}
  .newslist-pageindex a{display: inline-block;width: auto;height: 32px;background-color: #f2f2f2;color: #333333;font-size: 14px;line-height: 32px;min-width: 32px;box-sizing: border-box;padding: 0 5px; margin-left: 5px;margin-right: 5px;}
  .newslist-pageindex .active{background-color: #2a3c66;color:#fff}
  .newslist-pageindex a:hover{background-color: #2a3c66;color:#fff}
</style>



// WEBPACK FOOTER //
// src/page/download.vue